import React from 'react'
import { useMsal } from '@azure/msal-react'
import { StaticImage } from 'gatsby-plugin-image'
import ImageWatermark from './ImageWaterMark'
import { Box, Button, Container, Typography } from '@mui/material'
import { loginRequest } from '../utils/auth'
import Footer from './Footer'

/**
 * Renders a drop down button with child buttons for logging in with a popup or redirect
 * Note the [useMsal] package
 */
export const LoginPage = (): any => {
  const { instance } = useMsal()
  const postLoginRedirectKey = 'cih.postLoginRedirectPath'

  const handleLogin = (loginType: string): any => {
    if (loginType === 'redirect') {
      const browserWindow = globalThis.window
      const requestedPath = browserWindow === undefined
        ? '/'
        : `${browserWindow.location.pathname}${browserWindow.location.search}${browserWindow.location.hash}`

      if (browserWindow !== undefined && requestedPath.length > 0) {
        browserWindow.localStorage.removeItem(postLoginRedirectKey)
        browserWindow.sessionStorage.setItem(postLoginRedirectKey, requestedPath)
      }

      instance.loginRedirect({
        ...loginRequest,
        redirectStartPage: requestedPath
      }).catch((e) => {
        console.log(e)
      })
    }
  }
  return (
    <Container component='main'>
      <ImageWatermark />
      <Box
        sx={{
          marginTop: 20,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center'
        }}
      >
        <Typography className='login-page-title' mb={10} variant='h3'>Cloud Innovation Hub, at the heart of...</Typography>

        <StaticImage
          src='../images/Unilever-Logo.png'
          alt='Unilever Logo'
          width={400}
          loading='eager'
          placeholder='none'
          style={{ animation: 'none', opacity: 1 }}
        />

        <Button
          style={{ margin: '30px' }}
          sx={{ backgroundColor: 'rgb(48, 48, 197)' }}
          variant='contained'
          onClick={() => handleLogin('redirect')}
        >
          Sign in using Redirect
        </Button>
      </Box>

      <Footer />
    </Container>
  )
}
